import { render, staticRenderFns } from "./ProjectContentPosts.vue?vue&type=template&id=4a77b44b"
import script from "./ProjectContentPosts.vue?vue&type=script&lang=ts"
export * from "./ProjectContentPosts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports